import { Serializable } from "./serializable";

export class AuthenticationToken implements Serializable<AuthenticationToken> {
  public token: string;
  public tokenType: string;
  public creationDate: Date;
  public expirationDate: Date;

  /**
   * Transforms received object to AuthenticationToken entity
   * @param input
   * @returns AuthenticationToken entity
   */
  deserialize(input: any): AuthenticationToken {
    this.token = input.token;
    this.tokenType = input.tokenType;
    this.creationDate = this.deserializeDate(input.creationDate);
    this.expirationDate = this.deserializeDate(input.expirationDate);

    return this;
  }

  /**
   * Transforms AuthenticationToken entity to json object
   * @returns json object
   */
  private deserializeDate(date: string) {
    if (!date) {
      return null;
    } else {
      return new Date(date);
    }
  }

  isExpired(): boolean {
    return new Date() > this.expirationDate;
  }
}
